import React from "react";
import { Link } from "react-router";
import getPath from "../../../shared/utils/getPath";

export default function Footer() {
  return (
    <footer className="index-footer container-fluid">
      <Link to={getPath("frontend", "contact")}>Kontakt</Link>
      &nbsp;|&nbsp;
      <Link to={getPath("frontend", "project")}>Projekt</Link>
      &nbsp;|&nbsp;
      <Link to={getPath("frontend", "dsgvo")}>Datenschutz</Link>
      &nbsp;|&nbsp;
      <Link to={getPath("frontend", "impressum")}>Impressum</Link>
      <span className="hidden-xs">
        &nbsp;|&nbsp;
        <a href="https://www.bezirk-oberfranken.de/museum-und-schule">
          MUSbi ist ein Projekt der KulturServiceStelle des Bezirks Oberfranken
        </a>
      </span>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/Footer.js